module.exports = __webpack_public_path__ + "static/media/bg-nosotros.545d7d92.jpg";